import React, { useState, useEffect } from "react";
import { ErrorMessage, Field, Formik } from "formik";
import { Figure, Form, Modal } from "react-bootstrap";
import * as yup from "yup";
import { Input } from "../../../../../_metronic/_partials/controls";
import { ActionButton } from "../../../../../_metronic/_partials/controls/ActionButton";

const ProjectImageSchema = yup.object().shape({
  file: yup.mixed().required("File harus dipilih."),
  caption: yup.string().optional()
});

export const ProjectImageForm = ({ submit, show, onHide, loading = false }) => {
  function updateImage(event, setValue) {
    const { files } = event.target;

    if (files instanceof FileList) {
      setValue(files[0]);
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Tambah Foto</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          caption: "",
          file: null
        }}
        validationSchema={ProjectImageSchema}
        onSubmit={values => {
          submit(values, onHide);
        }}
      >
        {({ handleSubmit, values, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <div className="form-group row">
                <div className="col">
                  <label htmlFor="caption">Caption</label>
                  <Field
                    name="caption"
                    className="form-control"
                    component="textarea"
                    value={values.caption}
                    onChange={e => setFieldValue("caption", e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col d-flex flex-column">
                  <label htmlFor="file">Gambar</label>
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        name="file"
                        type="file"
                        className="custom-file-input"
                        accept="image/*"
                        id="project-image"
                        onChange={e =>
                          updateImage(e, value => setFieldValue("file", value))
                        }
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="project-image"
                      >
                        {values.file instanceof File
                          ? values.file.name
                          : "Choose file"}
                      </label>
                    </div>
                  </div>
                  <ErrorMessage
                    name="file"
                    render={msg => (
                      <span className="mt-2 text-danger">{msg}</span>
                    )}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col">
                  <Figure>
                    {values.file instanceof File && (
                      <Figure.Image src={URL.createObjectURL(values.file)} />
                    )}
                  </Figure>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-secondary mr-3"
                  onClick={onHide}
                >
                  Batal
                </button>
                <ActionButton type="submit" loading={loading} text="Simpan" />
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
